import React from 'react';



const Container = ({children}) => {
    return ( 
        <div id="outer-container">
            {children}
                 </div>
    );
}
 
export default Container;